import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Hero } from '@components/SectionBlocks/blocks/ThemeHeroBlock/Hero';
import { SectionContainer } from '../DynamicApp/DynamicApp.styles';

export const StyledHeroBlock = styled(Hero)`
  padding-top: ${spacing.space48};
`;

export const Main = styled.main`
  padding-top: ${spacing.space48};
`;

export const BylineRole = styled.span`
  font-style: italic;
`;

export const StyledSectionContainer = styled(SectionContainer)`
  padding-top: 0;
  row-gap: ${spacing.space48};

  /* Setting spacing here for section blocks to avoid having spacing on the blocks themselves interfere with grip-gap in other pages */
  .TextAndImageBlock,
  .ImageLinksBlock,
  .NavigationLinksBlock,
  .InputWithImageLinksBlock {
    margin-bottom: ${spacing.space80};

    @media (max-width: ${breakpoints.s}) {
      margin-bottom: ${spacing.space56};
    }
  }

  /* Centering text from TextBlock only on themepage */
  .TextBlock {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-gap: ${spacing.space24};

    .TextBlockItem {
      grid-column: 4 / span 6;

      @media (max-width: ${breakpoints.s}) {
        grid-column: 1 / span 12;
      }
    }
  }
`;

export const CenterContainer = styled.div`
  padding: 0 ${spacing.space48};
  margin: ${spacing.space48} auto;
  max-width: ${breakpoints.xl};
  box-sizing: border-box;

  @media (max-width: ${breakpoints.s}) {
    padding: 0 ${spacing.space24};
  }
`;
